<template>
    <div v-if="info" class="container-md container-fluid">
        <div class="row my-5">
            <div class="col-sm-8 text-gray-custom shadow blod-sm p-3" style="text-align: justify">
                <img :src="'https://blogs.heyvageneraltrading.com/'+info.picture" class="w-100 blod-sm mb-2" alt="">
                <span class="mt-5"><font-awesome-icon icon="fas fa-calendar" />{{ info.date2 }}</span>
                <div class=" my-5">
                    <h3 style="color:#000">{{ info.title }}</h3>
                    <div class="my-3" v-html="info.desc_title"></div>
                    <div class="my-3" v-html="info.description"></div>
                </div>
                <div class="mt-3 text-end" v-html="info.content_title"></div>
                <div class="mt-1 text-end justifys" v-html="info.maintext"></div>
                <h6 class="mt-1 text-end justifys font-weight-bold" v-html="info.result_title"></h6>
                <div class="mt-1 text-end justifys" v-html="info.result"></div>
                <h6 class="mt-5 text-end justifys font-weight-bold" v-html="info.faq_title"></h6>
                <div class="mt-1 text-end justifys font-weight-bold" v-html="info.question1"></div>
                <div class="mt-1 text-end justifys" v-html="info.answer1"></div>
                <div class="mt-1 text-end justifys font-weight-bold" v-html="info.question2"></div>
                <div class="mt-1 text-end justifys" v-html="info.answer2"></div>
                <div class="mt-1 text-end justifys font-weight-bold" v-html="info.question3"></div>
                <div class="mt-1 text-end justifys" v-html="info.answer3"></div>
            </div>
            <div class="col-sm-4 shadow blod-sm p-3">
                <div class="text-center">
                    <h5 class="py-2">پست های مشابه</h5>
                    <hr>
                </div>
                <div v-for="(item,i) in blogs" :key="i" class="row my-4">
                    <div class="col-lg-5 d-flex">
                        <a class="fs-6" style="cursor: pointer;text-decoration: none;" @click="goToPage(item.url)">
                        <img :src="'https://blogs.heyvageneraltrading.com/'+item.picture" class="w-100 blod-sm" alt=""></a>
                    </div>
                    <div class="col-lg-7 d-flex-block">
                        <a class="fs-6" style="cursor: pointer;text-decoration: none;" @click="goToPage(item.url)"><h6 style="color:#000">{{ item.title }}</h6></a>
                        <span style="color:gray">{{ item.date2 }}</span>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
library.add(faCalendar);
import { faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import BlogApiService from '@/ApiService/BlogApiServece';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';

export default defineComponent({
    components: { FontAwesomeIcon },
    setup() {
        library.add(faInstagram,faLinkedinIn)
        const info = ref()
        const blogs = ref()
        const router = useRouter()
      
        function getData(){
            console.log(router.currentRoute.value.params.url);
            
            BlogApiService.getBlogInfo(router.currentRoute.value.params.url).then(({data})=>{
                console.log(data);
                
                info.value = data.blogdetail;
                blogs.value = data.blogs
                setTimeout(() => {
                    var elements = document.getElementsByClassName('[class^="wp-image"]')
                    var numElements = elements.length;
                    for (var i = 0; i < numElements; i++) {
                        elements[i].style.width = '100% !important';
                    }
                }, 100);
            })
        }

        onMounted(()=>{
            getData();
        })

        function goToPage(url) {
            router.push({name: 'blog',params: { url:url }});
            setTimeout(() => {
                location.reload();
            }, 500);
            getData();
        }
      return {
        router,
        info,
        blogs,
        goToPage,
        getData
        
      }
  
    },
  })
</script>
<style scoped lang="scss">
    .blod-sm {
        border-radius: 10px;
    }

    .icon-style {
        background-color: #c9c9c9;
        color: white;
        width: 20px;
        height: 20px;
        padding: 5px;
        border: none;
        border-radius: 100%;
}
.bg2 {
    background-image: url('../../assets/img/blog/bg2.png');
    background-size: cover;
    border: none;
    border-radius: 30px;
}
@import url('/src/assets/scss/style-rtl.scss');
</style>